import {
	CreateNewSiteFloorParams,
	VelavuAPI,
	VelavuFloor,
} from "velavu-js-api";
import { getBase64FromUrl } from "../../helper/image-helper";

export interface PendingFloorDuplication {
	id: number;
	level: number;
	name: string;
}

export interface DuplicateFloorResult {
	pending: PendingFloorDuplication;
	promise: Promise<VelavuFloor>;
}

let pendingFloorIdCounter = 0;

export function requestDuplicateFloor(
	siteID: string,
	floor: VelavuFloor,
): DuplicateFloorResult {
	const pending: PendingFloorDuplication = {
		id: pendingFloorIdCounter,
		level: floor.level,
		name: `${floor.name} COPY`,
	};
	pendingFloorIdCounter += 1;

	const promise = (async (): Promise<VelavuFloor> => {
		//Create the request with floor data
		const request: CreateNewSiteFloorParams = {
			name: pending.name,
			level: pending.level,
			geometry: floor.geometry,
			img: floor.img,
		};

		//If the floor has an image, download and re-upload it
		if (floor.img !== undefined) {
			request.img_upload = await getBase64FromUrl(floor.img.url);
		}

		//Create new floor
		return await VelavuAPI.siteFloors.createNewSiteFloor(siteID, request);
	})();

	return {
		pending,
		promise,
	};
}
